import {
  GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_BEGIN,
  GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_SUCCESS,
  GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_FAILURE,
  GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getProductListActions(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_BEGIN,
    });
     params.size = 10;
    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
         request({
        url:'/api/public/gc/product/lng',
        method:'get',
        data:params
      }).then(
        (res) => {
          dispatch({
            type: GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_SUCCESS,
             data: Object.assign({},res,{page:params.page}),
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetProductListActionsError() {
  return {
    type: GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getProductListActionsPending: true,
        getProductListActionsError: null,
      };

    case GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_SUCCESS:
      // The request is success
      const byId = {};
        const items = [];
        action.data.data.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
      return {
        ...state,
         pro_lnglistById:byId,
          pro_lnglistList:items,
          pro_lnglistPage: action.data.page,
          pro_lnglistSize: action.data.size,
          pro_lnglistTotal: action.data.totalCount,
        getProductListActionsPending: false,
        getProductListActionsError: null,
      };

    case GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        getProductListActionsPending: false,
        getProductListActionsError: action.data.error,
      };

    case GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getProductListActionsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/gkproduct/redux/getProductListActions.js